const BRAND_STYLESHEET_ID = 'sso-brand-stylesheet';
const BRAND_STYLESHEET_PRELOAD_ID = 'sso-brand-stylesheet-preload';
const BRAND_STYLE_STATE_ATTRIBUTE = 'data-sso-brand-style-state';

const normalizeBrandStylesheetName = (brand?: string | null) => {
  const normalizedBrand = (brand || 'default').toLowerCase();

  if (normalizedBrand.startsWith('petsafe')) return 'petsafe';
  if (normalizedBrand.startsWith('sportdog')) return 'sportdog';
  if (normalizedBrand === 'kurgo') return 'kurgo';
  if (
    normalizedBrand === 'invisiblefence' ||
    normalizedBrand === 'invisiblefence_canada'
  ) {
    return 'invisiblefence';
  }

  return 'default';
};

export const getBrandStylesheetHref = (brand?: string | null) =>
  `/styles/${normalizeBrandStylesheetName(brand)}.css`;

const getBrandFromSearch = (search: string) => {
  const params = new URLSearchParams(search);
  return params.get('brand');
};

export const ensureBrandStylesheet = (search: string) => {
  if (typeof document === 'undefined') return;

  const stylesheetHref = getBrandStylesheetHref(getBrandFromSearch(search));
  const root = document.documentElement;
  const existingStylesheet = document.getElementById(
    BRAND_STYLESHEET_ID
  ) as HTMLLinkElement | null;

  if (existingStylesheet?.href.endsWith(stylesheetHref)) {
    root.setAttribute(BRAND_STYLE_STATE_ATTRIBUTE, 'ready');
    return;
  }

  root.setAttribute(BRAND_STYLE_STATE_ATTRIBUTE, 'loading');

  document.getElementById(BRAND_STYLESHEET_PRELOAD_ID)?.remove();
  existingStylesheet?.remove();

  const preloadLink = document.createElement('link');
  preloadLink.id = BRAND_STYLESHEET_PRELOAD_ID;
  preloadLink.rel = 'preload';
  preloadLink.as = 'style';
  preloadLink.href = stylesheetHref;
  preloadLink.setAttribute('fetchpriority', 'high');

  const stylesheetLink = document.createElement('link');
  stylesheetLink.id = BRAND_STYLESHEET_ID;
  stylesheetLink.rel = 'stylesheet';
  stylesheetLink.href = stylesheetHref;

  const markReady = () => {
    root.setAttribute(BRAND_STYLE_STATE_ATTRIBUTE, 'ready');
  };

  stylesheetLink.addEventListener('load', markReady, { once: true });
  stylesheetLink.addEventListener('error', markReady, { once: true });

  document.head.appendChild(preloadLink);
  document.head.appendChild(stylesheetLink);

  globalThis.setTimeout(markReady, 3000);
};

export const getBrandStylesheetBootstrapScript = () => `
(function () {
  var BRAND_STYLESHEET_ID = '${BRAND_STYLESHEET_ID}';
  var BRAND_STYLESHEET_PRELOAD_ID = '${BRAND_STYLESHEET_PRELOAD_ID}';
  var BRAND_STYLE_STATE_ATTRIBUTE = '${BRAND_STYLE_STATE_ATTRIBUTE}';

  function normalizeBrandStylesheetName(brand) {
    var normalizedBrand = (brand || 'default').toLowerCase();

    if (normalizedBrand.indexOf('petsafe') === 0) return 'petsafe';
    if (normalizedBrand.indexOf('sportdog') === 0) return 'sportdog';
    if (normalizedBrand === 'kurgo') return 'kurgo';
    if (
      normalizedBrand === 'invisiblefence' ||
      normalizedBrand === 'invisiblefence_canada'
    ) {
      return 'invisiblefence';
    }

    return 'default';
  }

  function getBrandStylesheetHref(search) {
    var params = new URLSearchParams(search);
    return '/styles/' + normalizeBrandStylesheetName(params.get('brand')) + '.css';
  }

  try {
    var root = document.documentElement;
    var stylesheetHref = getBrandStylesheetHref(window.location.search);
    var existingStylesheet = document.getElementById(BRAND_STYLESHEET_ID);
    var existingPreload = document.getElementById(BRAND_STYLESHEET_PRELOAD_ID);

    root.setAttribute(BRAND_STYLE_STATE_ATTRIBUTE, 'loading');

    if (existingStylesheet && existingStylesheet.getAttribute('href') === stylesheetHref) {
      root.setAttribute(BRAND_STYLE_STATE_ATTRIBUTE, 'ready');
      return;
    }

    if (existingPreload) existingPreload.remove();
    if (existingStylesheet) existingStylesheet.remove();

    var preloadLink = document.createElement('link');
    preloadLink.id = BRAND_STYLESHEET_PRELOAD_ID;
    preloadLink.rel = 'preload';
    preloadLink.as = 'style';
    preloadLink.href = stylesheetHref;
    preloadLink.setAttribute('fetchpriority', 'high');

    var stylesheetLink = document.createElement('link');
    stylesheetLink.id = BRAND_STYLESHEET_ID;
    stylesheetLink.rel = 'stylesheet';
    stylesheetLink.href = stylesheetHref;

    function markReady() {
      root.setAttribute(BRAND_STYLE_STATE_ATTRIBUTE, 'ready');
    }

    stylesheetLink.addEventListener('load', markReady, { once: true });
    stylesheetLink.addEventListener('error', markReady, { once: true });

    document.head.appendChild(preloadLink);
    document.head.appendChild(stylesheetLink);
    window.setTimeout(markReady, 3000);
  } catch (error) {
    document.documentElement.setAttribute(BRAND_STYLE_STATE_ATTRIBUTE, 'ready');
  }
})();
`;

export const getBrandStylesheetGuardCss = () => `
html[${BRAND_STYLE_STATE_ATTRIBUTE}='loading'] body {
  visibility: hidden;
}
`;
